/**
 * 注意：
 * media_type 相关配置，请使用 @/lib/enum.js 下的 getMedia() 方法，保持统一的配置源
 */
export const MEDIA_TYPE_DESC = {
  ws: '腾讯微视',
  kg: '全民K歌',
  om: '企鹅号',
  qq: 'QQ',
  txvideo: '腾讯视频',
  kdlive: '看点直播',
  kd_app: '看点App',
  qq_xsj: 'QQ小世界',
};

export const MEDIA_TYPE_DESC_D = {
  腾讯微视: 'ws',
  全民K歌: 'kg',
  企鹅号: 'om',
  QQ: 'qq',
  腾讯视频: 'txvideo',
  看点直播: 'kdlive',
  看点App: 'kd_app',
  QQ小世界: 'qq_xsj',
};

export const MEDIA_TYPE = {
  ws: 'ws',
  kg: 'kg',
  om: 'om',
  qq: 'qq',
  txvideo: 'txvideo',
  kdlive: 'kdlive',
  kd_app: 'kd_app',
  qq_xsj: 'qq_xsj',
};

export const COUPON_TYPE = {
  1: '自营券',
  2: '商家券',
};

export const COUPON_STATUS = {
  0: '未发放',
  1: '发放中',
  2: '暂停发放',
  3: '已发完',
  4: '已失效',
};

export const COUPON_OPERATOR = {
  0: '立即发券',
  1: '暂停发券',
  2: '继续发券',
  3: '立即发券', // 置灰
  4: '立即发券',  // 置灰
};

export const GRANTMANNER = {
  2: '用户领取', // 上架
  4: '定向发放', // 置灰但隐藏
};

export const LIVE_ROOM_STATUS = {
  0: '直播中',
  1: '已结束',
};

// 注册填写资料的方式
export const IDENTITY_TYPE = {
  person: 0,
  company: 1,
};
